module.exports = __webpack_public_path__ + "static/img/slider-3.73389c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/static-css/img/slider/slider-3.jpg
// module id = WTFB
// module chunks = 19